/* eslint-disable comma-dangle */
import React from 'react'
import PropTypes from 'prop-types'
import FormInput from 'components/forms/bases/FormInput'

const TextSwitcher = ({
  isEditing,
  value,
  inputProps,
  onChange,
}) => {
  if (!isEditing) {
    return (
      <span>{value}</span>
    )
  }
  return (
    <FormInput
      value={value}
      onChange={onChange}
      {...inputProps}
    />
  )
}

TextSwitcher.propTypes = {
  isEditing: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
  inputProps: PropTypes.object,
}
TextSwitcher.defaultProps = {
  isEditing: false,
  value: '',
  onChange: () => {},
  inputProps: {},
}

export default TextSwitcher



// WEBPACK FOOTER //
// ./src/components/forms/bases/TextSwitcher.js